import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useTeamPermission } from '../../hooks/useTeamPermission';
import { PageLoading } from '../common/LoadingSpinner';
import { ROUTES, USER_TYPES } from '../../constants/constants';

const PrivateRoute = ({
  children,
  requireAuth = true,
  allowedUserTypes = null,
  requiredPermissions = null,
  fallbackPath = ROUTES.LOGIN
}) => {
  const {
    isAuthenticated,
    isLoading,
    userType,
    isSearchTypeAllowed
  } = useAuth();

  // For client_child_user: Team_Management_Permission lives on the firm's license,
  // NOT in the user's own search_types_allowed — use hasTeamManagementAccess from the hook
  const { hasTeamManagementAccess, loading: permsLoading } = useTeamPermission();

  if (isLoading || (userType === USER_TYPES.CLIENT_USER && permsLoading)) {
    return <PageLoading message="Checking authentication..." />;
  }

  // 1. Auth check
  if (requireAuth && !isAuthenticated) {
    return <Navigate to={fallbackPath} replace />;
  }

  // 2. User type check
  if (allowedUserTypes && !allowedUserTypes.includes(userType)) {
    return <Navigate to={ROUTES.UNAUTHORIZED} replace />;
  }

  // 3. Permission check
  if (requiredPermissions && requiredPermissions.length > 0) {
    const hasAllPermissions = requiredPermissions.every((perm) => {
      // Team_Management_Permission for child users: check firm license via hook
      if (perm === 'Team_Management_Permission' && userType === USER_TYPES.CLIENT_USER) {
        return hasTeamManagementAccess;
      }
      return isSearchTypeAllowed(perm);
    });

    if (!hasAllPermissions) {
      // console.log('[PrivateRoute] REDIRECT → missing permissions', requiredPermissions);
      return <Navigate to={ROUTES.UNAUTHORIZED} replace />;
    }
  }

  // 4. Allowed → render page
  return children;
};

export default PrivateRoute;